export const EmailNameConsultationCaptureAbTestVariant0 = '0';
export const EmailNameConsultationCaptureAbTestVariant1 = '1';
export const EmailNameConsultationCaptureAbTestVariant2 = '2';
